import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Components/Header/header";
import Footer from "../Components/Footer/footer";
import "./MainLayout.scss";

const MainLayout = () => {
  return (
    <div className="sv-lux-v4-layout">
      <Header />
      <main className="sv-lux-v4-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
